/**
 * theme-fleet — mirrors the ClientApp2 (carfixfleet) design system, adapted for MUI v4.
 * Isolated: does NOT affect the existing theme in src/theme. Applied only via <ThemeProvider>.
 * Source: ClientApp2/src/theme/DefaultColors.tsx
 */
const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#37AFAD',
      light: '#ECF2FF',
      dark: '#4570EA',
      extraLight: '#EFF9FF',
      extraLight2: '#EBF9FA'
    },
    secondary: {
      main: '#FF7345',
      light: '#FF9A79',
      dark: '#23afdb',
      extraLight: '#EFF9FF',
      extraLight2: '#FFF5F2'
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#ffffff'
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#1682d4',
      contrastText: '#ffffff'
    },
    error: {
      main: '#FA896B',
      light: '#FBF2EF',
      dark: '#f3704d',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#ffffff',
      custom: '#FF7345'
    },
    light: {
      main: '#FFFFFF',
      light: '#EFF9FF',
      dark: '#f3704d',
      contrastText: '#37AFAD'
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9'
    },
    grey: {
      100: '#F6F9FC',
      200: '#EAEFF4',
      300: '#DFE5EF',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#F2F6FA'
    },
    text: {
      primary: '#000000',
      secondary: '#000000',
      black: '#000000',
      disabled: 'rgba(42, 53, 71, 0.97)'
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc'
    },
    divider: '#e5eaef',
    background: {
      default: '#FFF'
    },
    chip: {
      fill: 'rgba(0, 0, 0, 0.08)'
    },
    box: {
      lightShadow:
        '0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)'
    }
  }
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: { main: '#5D87FF', light: '#ECF2FF', dark: '#4570EA' },
    secondary: { main: '#777e89', light: '#1C455D', dark: '#173f98' },
    text: { primary: '#EAEFF4', secondary: '#7C8FAC' },
    divider: '#333F55',
    background: { default: '#171c23', dark: '#171c23', paper: '#171c23' }
  }
};

export { baseDarkTheme, baselightTheme };
